<!--
 * @description:
 * @author: cuicui
 * @Date: 2023-01-20 00:11:06
 * @LastEditTime: 2025-09-04 09:54:09
 * @LastEditors: fusiyuan 1152054863@qq.com
-->
<template functional>
  <div class="user-state-label-wrapper">
    <template v-if="props.status === $options.status().waitAudit">
      <i
        class="el-icon-circle el-icon-time"
        style="background-color: #00bd83"
      ></i>
      <span style="color: #00bd83">待审核</span>
    </template>
    <template v-else-if="props.status === $options.status().finished">
      <i
        class="el-icon-circle el-icon-circle-check"
        style="background-color: #005bff"
      ></i>
      <span style="color: #005bff">登记成功</span>
    </template>
    <template
      v-else-if="['failed', 'failure', 'inProgress'].includes(props.status)"
    >
      <i
        class="el-icon-circle el-icon-circle-close"
        style="background-color: #ff5753"
      ></i>
      <span style="color: #ff5753">登记失败</span>
    </template>
  </div>
</template>

<script>
import { STATUS } from "../_eum";
export default {
  name: "userStateLabel",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  status() {
    return STATUS;
  },
};
</script>

<style lang="scss">
.user-state-label-wrapper {
  display: flex;
  align-items: center;
  // .state-label {
  //   height: 20px;
  //   width: 20px;
  //   padding: 2px;
  //   border-radius: 50%;
  //   line-height: 16px;
  i {
    margin-right: 9px;
  }
  // }
}
</style>
